var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.runners)?_c('span',{staticClass:"d-inline-flex"},[(_vm.runners.back)?_c('span',{staticClass:"ml-1 secondary black--text px-1"},[_vm._v("\n    "+_vm._s(_vm.back)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.runners.lay)?_c('span',{staticClass:"accent black--text px-1"},[_vm._v("\n    "+_vm._s(_vm.lay)+"\n  ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }